// eslint-disable-next-line jira/import-whitelist
import { fireErrorAnalytics } from '@jira/platform__error-reporting/src/fireErrorAnalytics.tsx';
import { performPostRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import type { UserPreferences } from './UserPreferences.types.tsx';

export const getUserPreferencesQuery = (keys: string[]): string => `
query WorkflowEditorPreferenceQuery {
    myPreferences(keys: [${keys.map((key) => `"${key}"`).join(', ')}])
}
`;

type ApiResult = {
	data: {
		myPreferences: Record<string, string | null>;
	};
};

export const getUserPreferences = async (keys: string[]): Promise<UserPreferences> => {
	try {
		const apiResult: ApiResult = await performPostRequest('/rest/gira/1/', {
			body: JSON.stringify({
				query: getUserPreferencesQuery(keys),
			}),
		});

		return apiResult.data.myPreferences;
	} catch (error) {
		fireErrorAnalytics({
			error: error instanceof Error ? error : undefined,
			meta: {
				id: 'getUserPreferences',
				packageName: 'jiraAdminPagesWorkflowsUserPreferences',
				teamName: 'Helix',
			},
		});

		throw error;
	}
};
